
import DepsService from 'services/dependencies';

const CONTEXT = 'cms';

const getTermsOfUseUrl = (secondHandApproval) => {
  if (secondHandApproval) return DepsService.rest.cms.terms.view.second.url;
  return DepsService.rest.cms.terms.view.first.url;
};

const getPrivacyPolicyeUrl = (secondHandApproval) => {
  if (secondHandApproval) return DepsService.rest.cms['privacy-policy'].second.url;
  return DepsService.rest.cms['privacy-policy'].first.url;
};

const transformAttachments = (attachments) => {
  const localeKey = Object.keys(attachments);
  const payload = {};

  localeKey.forEach((locale) => {
    if (attachments[locale]) {
      payload[locale] = [{
        name: attachments[locale][0].name,
        id: attachments[locale][0].id,
        content: attachments[locale][0].fileSource,
      }];
    }
  });

  return payload;
};

const fetchTermsOfUse = ({ secondHandApproval, jurisdictionId }) => {
  const url = getTermsOfUseUrl(secondHandApproval);
  const queryParams = { locale: '*' };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

const fetchPrivacyPolicy = ({ secondHandApproval, jurisdictionId }) => {
  const url = getPrivacyPolicyeUrl(secondHandApproval);
  const queryParams = { locale: '*' };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

const savePrivacyPolicy = ({ fields, attachments, jurisdictionId }) => {
  const { url } = DepsService.rest.cms['privacy-policy'].first;
  const payload = {
    jurisdictionId,
    entries: [
      {
        fields,
        attachments,
      },
    ],
  };

  const urlParams = {};

  return DepsService.restSrv.update(CONTEXT, url, payload, urlParams);
};

const saveTermsOfUse = ({ fields, attachments, title }) => {
  const { url } = DepsService.rest.cms.terms.update.first;
  const payload = {
    title,
    fields,
    attachments: transformAttachments(attachments),
  };

  const urlParams = {};

  return DepsService.restSrv.update(CONTEXT, url, payload, urlParams);
};

// eslint-disable-next-line consistent-return
const saveTerms = ({ termsType, ...payload }) => {
  switch (termsType) {
    case 'privacyPolicy':
      return savePrivacyPolicy(payload);
    case 'termsOfUse':
      return saveTermsOfUse(payload);
    default:
      // eslint-disable-next-line no-console
      console.error('CMS_TERMS_MANAGMENT', `Cannot match terms type to: ${termsType}`);
  }
};

const downloadTerms = async (contentId, name) => {
  const { url } = DepsService.rest.cms.terms.download;
  const queryParams = {};
  const urlParams = { contentId };

  const reports = await DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams);

  const result = await reports.promise;

  window.saveAs(result.data, name);
};

export default {
  fetchTermsOfUse,
  fetchPrivacyPolicy,
  saveTerms,
  downloadTerms,
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/terms-management.api.js